export default {
  sustentabilidade: {
    // logo_topo: require('./logos/logo-topo.png'),
    // logo_mobile: require('./logos/logo-mobile.png'),
    img1: require('./sustentabilidade/foto_loja_pao-de-acucar.jpg'),
    icone1: require('./sustentabilidade/icone1.png'),
    icone2: require('./sustentabilidade/icone2.png'),
    icone3: require('./sustentabilidade/icone3.png'),
    icone4: require('./sustentabilidade/icone4.png'),
    conceito: require('./sustentabilidade/conceito.png'),
    iniciativas: require('./sustentabilidade/iniciativas.png')
  },
  logo: {
    logo_topo: require('./logos/logo-topo.png'),
    logo_mobile: require('./logos/logo-mobile.png'),
    logo_sustentabilidade: require('./sustentabilidade/logo-sustentabilidade.png'),

  },
  // logo: {
  //   logo_topo: require('./logos/logo-topo.png'),
  //   logo_mobile: require('./logos/logo-mobile.png'),
  //   logo_pa: require('./logos/logo-topo.png'),
  //   logo_pa_mais: require('./logos/logo_pa_mais.png'),
  //   logo_clube_ex: require('./logos/logo_clube_ex.png'),
  //   //small
  //   logo_pa_mais_small: require('./logos/logo-mobile.png'),
  //   //minuto
  //   logo_minuto_pa: require('./logos/logo_minuto.png'),
  //   logo_pa_posto: require('./logos/logo_pa_posto.png'),
  //   logo_pa_com: require('./logos/logo_pa_com.png'),
  //   logo_pa_drogaria: require('./logos/logo_pa_drogaria.png')
  // },
  // stocks: {
  //   family_buying: require('./stocks/family_buying.png'),
  //   my_discount_cellphone: require('./stocks/celular_meu_desconto.png'),
  //   my_awards_cellphone: require('./stocks/celular_meus_premios.png'),
  //   my_prizes_background: require('./stocks/fundo-my-prizes.jpg'),
  //   my_awards: require('./stocks/meus_premios.png'),
  //   my_awards_mobile: require('./stocks/meus_premios_mobile.png'),
  //   my_discount: require('./stocks/meu_desconto.png'),
  //   my_discount_mobile: require('./stocks/meu_desconto_mobile.png')
  // },
  icons: {
    airplane: require('./icons/airplane.png'),
    app_store: require('./icons/app_store.png'),
    facebook: require('./icons/facebook.png'),
    google_play: require('./icons/google_play.png'),
    phone: require('./icons/phone.png'),
    twitter: require('./icons/twitter.png'),
    youtube: require('./icons/youtube.png'),
    phone_white: require('./icons/phone_white.png'),
    airplane_white: require('./icons/airplane_white.png'),
    icon_snapchat: require('./icons/001-snapchat.png'),
    icon_facebook: require('./icons/003-facebook.png'),
    icon_instagram: require('./icons/004-instagram.png'),
    icon_youtube: require('./icons/005-youtube.png'),
    icon_twitter: require('./icons/006-twitter.png'),
  },
  // benefits: {
  //   benefit_caixa_express_icon: require('./icons/beneficio_caixa_express_icon.png'),
  //   benefit_descontos_exclusivos_icon: require('./icons/beneficio_descontos_exclusivos_icon.png'),
  //   benefit_meu_desconto_icon: require('./icons/beneficio_meu_desconto_icon.png'),
  //   benefit_meus_premios_icon: require('./icons/beneficio_meus_premios_icon.png'),
  //   benefit_minha_lista_icon: require('./icons/beneficio_minha_lista_icon.png'),
  //   benefit_caixa_express: require('./benefits/beneficio_caixa_express.png'),
  //   benefit_descontos_exclusivos: require('./benefits/beneficio_descontos_exclusivos.png'),
  //   benefit_meu_desconto: require('./benefits/beneficio_meu_desconto.png'),
  //   benefit_meus_premios: require('./benefits/beneficio_meus_premios.png'),
  //   benefit_minha_lista: require('./benefits/beneficio_minha_lista.png')
  // }
}



// WEBPACK FOOTER //
// ./src/assets/images/index.js